import { ChakraProvider } from '@chakra-ui/react';
import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { SERVER_URL } from "../data/constants";
import { boardSelectorTheme } from '../data/theme';
import { Loader } from "./Loader";
import boardSelectorHeaderDrawing from '../assets/images/board_selector_header_drawing.png';
import { ReactComponent as PresentationSelectionIcon } from '../assets/images/presentation-selection-icon.svg';
import { ReactComponent as ChevronRight } from '../assets/images/chevron-right.svg';

export default function BoardSelector() {
    const [error, setError] = useState(null)
    const [boardsAreLoaded, setBoardsAreLoaded] = useState(false)
    const [boards, setBoards] = useState([])

    const navigate = useNavigate();

    useEffect(() => {
        fetch(SERVER_URL + "/boards")
            .then(res => {
                console.log(res);
                return res.json()
            })
            .then((data) => {
                setBoardsAreLoaded(true)
                setBoards(data)
            }, (error) => {
                setBoardsAreLoaded(false)
                setError(error)
            })
    }, [])

    const goToPresentation = (presentationId: number) => {
        navigate(`/presentations/${presentationId}`);
    }

    if (error) {
        return <div>Error: {error}</div>;
    } else if (!boardsAreLoaded) {
        return (<Loader />);
    } else {
        return (
            <ChakraProvider theme={boardSelectorTheme}>
                <div className={"presentation-selection-container"}>
                    <div className='presentation-selection-main-column'>
                        <div className='presentation-selection-header'>
                            <h1>Moments that Matter</h1>
                            <img
                                src={boardSelectorHeaderDrawing}
                                alt='' />
                        </div>
                        <div className='presentation-selection-body'>
                            <h2>Please select a presentation</h2>
                            <div className='presentation-selection-list'>
                                {boards.map(board => (
                                    <div
                                        key={board['id']}
                                        className='presentation-selection-item'
                                        onClick={e => goToPresentation(board['id'])} >
                                        <div className='presentation-selection-item-left-content'>
                                            <div>
                                                <PresentationSelectionIcon />
                                            </div>

                                            <h4>{board['title']}</h4>
                                        </div>

                                        <ChevronRight />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </ChakraProvider>
        );
    }
}
